module.exports = __webpack_public_path__ + "img/dollar-sign.cad8ddc1.svg";